import React from 'react';
import './SubHeading.css';

const SubHeading = ({ text, isItalic = false }) => {

    let className = ['sub-heading'];
    if(isItalic) {
        className.push('is-italic');
    }
    return (<div className={className.join(' ')}>{ text }</div>)
}

export default SubHeading;